export default __webpack_public_path__ + "static/media/11.7044717e.png";